
/**
 * 언어별 기본 정보
 */
export interface CourseDraftLocalizedBasicInfo {
  /**
   * 해당 언어의 설명
   * @nullable
   */
  description?: string | null;
  /** 해당 언어의 제목 */
  title: string;
}
